const hook = {
    missing_events: 'Bạn cần cung cấp ít nhất một sự kiện.',
    send_test_payload_failed: 'Gửi payload thử nghiệm thất bại: {{message}}',
    endpoint_responded_with_error: 'Endpoint phản hồi lỗi.',
};
export default Object.freeze(hook);
